<template>
  <div class="add-dialog">
    <el-dialog title="家校沟通新增" :close-on-click-modal="false" :visible.sync="communicationAddDialogShow" width="1000px"
      :before-close="dialogClose" @open="dialogOpen">
      <!-- 学年学期 -->
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px" class="ruleForm" label-position="top"
        :inline="true">
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <!-- <el-date-picker style="width: 235px" v-model="formData.schoolYear" type="year" value-format="yyyy"
            placeholder="请选择学年" @change="schoolYearChangeHandle">
          </el-date-picker> -->
          <year-range-picker style="width: 250px;" v-model="formData.schoolYear" />

        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="formData.semester" placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" label-position="top"
        :inline="true">
        <el-form-item label="沟通时间:" label-width="100px" prop="communicationTime">
          <el-date-picker style="width: 235px" v-model="ruleForm.communicationTime" type="date" value-format="yyyy-MM-dd" placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="沟通地点" prop="communicationPlace" class="title">
          <el-input v-model="ruleForm.communicationPlace" placeholder="请输入地点"></el-input>
        </el-form-item>
      </el-form>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm"
        label-position="top">
        <el-form-item label="沟通内容" prop="communicationContent">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" v-model="ruleForm.communicationContent"
            :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="沟通结果" prop="communicationResult">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" v-model="ruleForm.communicationResult"
            :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
      </el-form> -->
      <!-- <div class="upload">
        <el-upload class="upload" :auto-upload="false" :action="action" list-type="picture-card"
          accept=".jpg,.png,.jpeg" multiple :http-request="uploadFile" ref="upload" :limit="3" :on-change="onChange"
          :on-remove="onRemove" :on-preview="handlePictureCardPreview" :on-exceed="onExceed">
          <div class="iconfont icon-camera add"></div>
        </el-upload>
      </div> -->
      <div class="visit-form-container">
        <el-form ref="formRef" :model="formData" :rules="rules">
          <!-- 第一行：沟通方式、时间、地点、被访学生 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="沟通方式" prop="commMethod">
                <el-radio-group v-model="formData.commMethod">
                  <el-radio :label="item.dictLabel" v-for="(item, index) in communicationMethodOptions" :key="index">{{
                    item.dictLabel }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="时间" prop="interviewTime">
                <!-- <el-input v-model="formData.interviewTime" placeholder="请输入时间" /> -->
                <el-date-picker ref="datePicker" v-model="formData.interviewTime" type="date" value-format="yyyy-MM-dd"
                  placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="地点" prop="interviewAddress">
                <el-input v-model="formData.interviewAddress" placeholder="请输入地点" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="被访学生" prop="studentName">
                <el-input v-model="formData.studentName" placeholder="请输入被访学生" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行：被访家长、其他人员、谈话主题 -->
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="被访家长" prop="interviewee">
                <el-input v-model="formData.interviewee" placeholder="请输入被访家长" />
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="其他人员" prop="otherPersonnel">
                <el-input v-model="formData.otherPersonnel" placeholder="请输入其他人员" />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="谈话主题" prop="talkTopic">
                <el-input v-model="formData.talkTopic" placeholder="请输入谈话主题" />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 学生最近情况 -->
          <el-form-item label="一、学生最近情况" prop="studentRecentStatus">
            <el-input type="textarea" v-model="formData.studentRecentStatus" :rows="4" maxlength="1000" show-word-limit
              placeholder="请输入学生最近情况..." />
          </el-form-item>

          <!-- 家长家庭教育方式 -->
          <el-form-item label="二、家长教育方式或观念、孩子在家表现" prop="interviewContent">
            <el-input type="textarea" v-model="formData.interviewContent" :rows="4" maxlength="1000" show-word-limit
              placeholder="请输入家长教育方式和孩子在家表现..." />
          </el-form-item>

          <!-- 家庭教育指导建议 -->
          <el-form-item label="三、家庭教育指导建议" prop="guideSuggestions">
            <el-input type="textarea" v-model="formData.guideSuggestions" :rows="4" maxlength="1000" show-word-limit
              placeholder="请输入家庭教育指导建议..." />
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-list">
        <el-button type="primary" @click="submit">确认</el-button>
      </div>
      <!-- 图片预览 -->
      <!-- <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog> -->
    </el-dialog>
  </div>
</template>

<script>
import { baseURL } from "@/api/request"; // 服务器地址
import axios from "axios";
export default {
  props: [
    'communicationAddDialogShow', 'semesterOptions', 'studentId', 'studentName', 'communicationMethodOptions'
  ],
  data() {
    // 公共必填规则
    const requiredRule = (message = '该字段不能为空') => [
      { required: true, message, trigger: 'blur' }
    ];
    const noRequiredRule = (message = '该字段不能为空') => [
      { required: false, message, trigger: 'blur' }
    ];
    const requiredRuleChange = (message = '该选项不能为空') => [
      { required: true, message, trigger: 'change' }
    ];
    return {
      maxlength: 1000,
      // 表单数据模型
      formData: {
        commMethod: '家访', // 默认值
        interviewTime: '',
        interviewAddress: '',
        studentName: '',
        interviewee: '',
        otherPersonnel: '',
        talkTopic: '',
        studentRecentStatus: '',
        interviewContent: '',
        guideSuggestions: '',
        schoolYear: '',
        semester: '',
      },
      // 所有字段都为必填项
      rules: {
        commMethod: requiredRuleChange('请选择沟通方式'),
        interviewTime: requiredRule('请输入时间'),
        interviewAddress: requiredRule('请输入地点'),
        studentName: requiredRule('请输入被访学生姓名'),
        interviewee: requiredRule('请输入被访家长姓名'),
        otherPersonnel: noRequiredRule('请输入其他人员'),
        talkTopic: requiredRule('请输入谈话主题'),
        studentRecentStatus: requiredRule('请输入学生最近情况'),
        interviewContent: requiredRule('请输入家长教育方式及表现'),
        guideSuggestions: requiredRule('请输入家庭教育指导建议'),
        schoolYear: requiredRuleChange('请选择学年'),
        semester: requiredRuleChange('请选择学期')
      },
      action: "", // 文件上传路径
      // 待提交的图片
      fileList: [],
      count: 1,
      // formData: "",
      // 预览参数
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  methods: {
    // 保存表单数据
    saveForm() {
      console.log('表单数据:', this.formData);
      // 这里可以添加保存逻辑
    },

    // 清空表单
    clearForm() {
      this.formData = {
        commMethod: '家访', // 默认值
        interviewTime: '',
        interviewAddress: '',
        studentName: this.studentName,
        interviewee: '',
        otherPersonnel: '',
        talkTopic: '',
        studentRecentStatus: '',
        interviewContent: '',
        guideSuggestions: '',
        schoolYear: '',
        semester: '',
      }
    },
    // 开启弹窗
    dialogOpen() {
      this.action = `${baseURL}${this.$url.insertSchoolHomeInterview}`;
      this.formData = {
        commMethod: '家访', // 默认值
        interviewTime: '',
        interviewAddress: '',
        studentName: this.studentName,
        interviewee: '',
        otherPersonnel: '',
        talkTopic: '',
        studentRecentStatus: '',
        interviewContent: '',
        guideSuggestions: '',
        schoolYear: this.school.schoolYear,
        semester: this.school.semester,
      }
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:communicationAddDialogShow", false);

      // this.$refs.upload.clearFiles();
      // this.formData = "";
      // this.fileList = [];
      // this.count = 1;
      this.$refs["formRef"].clearValidate(); //移除表单检验结果
    },
    submit() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          let { commMethod, ...restFormData } = this.formData;

          let data = {
            ...restFormData,
            commMethod: this.communicationMethodOptions.find(
              item => item.dictLabel === this.formData.commMethod
            ).dictValue,
            schoolId: this.school.id,
            schoolName: this.school.schoolName,
            studentId: this.studentId,
            studentName: this.studentName,
            teacherId: this.user.id,
            teacherName: this.user.teacherName,
          };

          let config = {
            headers: {
              bbfAdminTeacherToken: window.localStorage.getItem("bbfAdminTeacherToken"),
              "Content-Type": "multipart/form-data",
            },
          };

          // 转换为 FormData
          const formActionData = new FormData();
          Object.entries(data).forEach(([key, value]) => {
            formActionData.append(key, value);
          });

          // 调用接口
          axios
            .post(this.action, formActionData, config)
            .then((res) => {
              // res.data 服务器返回的数据
              console.log(res);
              if (res.data.code == 200) {
                // 上传成功，刷新列表，关闭dialog
                this.$message.success(res.data.msg);
                this.$emit("refresh");
                this.dialogClose();
                return;
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });

        } else {
          return false;
        }
      });
    },
    schoolYearChangeHandle(e) {

    },
    // 文件超出个数限制时
    onExceed(file, fileList) {
      return this.$message("最多可上传三张");
    },
    // 上传预览图片时调用
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 移除图片时被调用
    onRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 添加文件、上传成功和上传失败时都会被调用
    onChange(file, fileList) {
      let limit = file.size / 1024 / 1024 < 2;
      let file_type = file.name.split(".")[1];
      if (!/^(jpg|png|jpeg)$/g.test(file_type)) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("请选择jpg,png,jpeg类型文件");
      } else if (!limit) {
        this.$refs.upload.clearFiles();
        return this.$message.warning("上传图片大小不能超过 2MB!");
      } else {
        this.fileList = fileList;
      }
    },
    // 覆盖默认的上传行为，可以自定义上传的实现
    // 向FormData对象设置文件
    uploadFile(file) {
      this.formData.append("file", file.file);
      this.count++;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./communicationAddDialog.scss";
</style>